import api_login from './api-manager/login'

export default  {
  api_login
}